export default (state = { isPinging: false }, action) => {
  switch (action.type) {
    case 'PING':
      return { isPinging: true }

    case 'PONG':
      return { isPinging: false }

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/ping.js
 **/